import { useTranslation } from 'next-i18next'
import { SyntheticEvent } from 'react'

import ROUTES from '~/shared/constants/routes.const'
import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { MULT_GAME } from '~/statistics/constants'
import { convertMsToDayHourMinute } from '~/user-stats/utility/date.utils'

import TimeSpent from '../TimeSpent'
import SummaryHeader from '../SummaryHeader'

interface Props {
  showContent: boolean
  onClick: () => void
  timeSpent: number
}

export default function MultGameSummary({ showContent, onClick, timeSpent }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  const { days, hours, minutes } = convertMsToDayHourMinute(timeSpent)

  const onClickTitle = (evt: SyntheticEvent): void => {
    evt.stopPropagation()
    statisticsAnalytics.logProductTileClick({ title: MULT_GAME })
  }

  return (
    <button className="w-full space-y-3" onClick={onClick}>
      <SummaryHeader
        cardTitle={MULT_GAME}
        iconAltText={MULT_GAME}
        iconSrcKey="scoreboard/mult-game.png"
        onClickTitle={onClickTitle}
        productHref={ROUTES.MULT_GAME}
        productSubtitle={t('multGame.multiplication')}
        productTitle={t('game')}
        showContent={showContent}
      />
      <div className="font-medium flex flex-start">
        <TimeSpent days={days} hours={hours} minutes={minutes} />
      </div>
    </button>
  )
}
